import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IYarn, IYarnPOrder } from "../../modules/raw-material/models/yarn";
import { IAccessory, IAccessoryPOrder } from "../../modules/orders/models/accessory";
import { ILsp, ILspPOrder } from "../../modules/orders/models/lsp";
import type { PurchaseOrderMode } from "../../modules/raw-material/models/rmm_models";

interface IAccessoryState {
  globalAccessories: IAccessory[];
  selectedAccessoryPO: IAccessoryPOrder | undefined;
  selectedAccessoryPoID: number;
  apoActionType: PurchaseOrderMode;
  apoPriceUnit: number | undefined;
}
interface IYarnState {
  selectedYarn: Array<IYarn>;
  selectedYarnPO: IYarnPOrder | undefined;
  selectedYarnPoID: number;
  ypoActionType: PurchaseOrderMode;
}
interface ILspState{
  selectedLsp: Array<ILsp>;
  selectedLspPO: ILspPOrder | undefined;
  selectedLspPoID: number;
  lspoActionType: PurchaseOrderMode;
}
interface SelectedPOStates{
    yarn:IYarnState;
    accessory:IAccessoryState;
    lsp:ILspState
}
const initialYarnState: IYarnState = {
  selectedYarn: [],
  selectedYarnPO: undefined,
  selectedYarnPoID: 0,
  ypoActionType: "create",

};
const initialAccessoryState: IAccessoryState = {
  globalAccessories: [],
  selectedAccessoryPO: undefined,
  selectedAccessoryPoID: 0,
  apoActionType: "create",
  apoPriceUnit: undefined,
};
const initialLspState:ILspState={
  selectedLsp:[],
  selectedLspPO: undefined,
  selectedLspPoID: 0,
  lspoActionType: "create",
}
const initialState: SelectedPOStates = {
    yarn:initialYarnState,
    accessory:initialAccessoryState,
    lsp:initialLspState
};

const selectedPurchaserSlice = createSlice({
  name: "selectedPurchaser",
  initialState,
  reducers: {
    initiateSelectedYarn: (state) => {
      state.yarn.selectedYarn = [];
    },
    initiateYarnPO: (state) => {
      state.yarn.selectedYarnPO = undefined;
      state.yarn.selectedYarnPoID = 0;
    },
    setSelectedYarn: (state, action: PayloadAction<Array<IYarn>>) => {
      state.yarn.selectedYarn = action.payload;
    },
    setSelectedYarnPO: (state, action: PayloadAction<IYarnPOrder>) => {
      state.yarn.selectedYarnPO = action.payload;
    },
    setSelectedYarnPoId: (state, action: PayloadAction<number>) => {
      state.yarn.selectedYarnPoID = action.payload;
    },
    setYpoActionType: (state, action: PayloadAction<PurchaseOrderMode>) => {
      state.yarn.ypoActionType = action.payload;
    },
    initiateSelectedAccessory: (state) => {
      state.accessory.globalAccessories = [];
    },
    addAccessory(state, action: PayloadAction<Array<IAccessory>>) {
      state.accessory.globalAccessories = action.payload;
    },
    initiateAccessoryPO: (state) => {
      state.accessory.selectedAccessoryPO = undefined;
      state.accessory.selectedAccessoryPoID = 0;
    },
    setSelectedAccessoryPO: (
      state,
      action: PayloadAction<IAccessoryPOrder>
    ) => {
      state.accessory.selectedAccessoryPO = action.payload;
    },
    setSelectedAccessoryPoId: (state, action: PayloadAction<number>) => {
      state.accessory.selectedAccessoryPoID = action.payload;
    },
    setAccessoryActionType: (state, action: PayloadAction<PurchaseOrderMode>) => {
      state.accessory.apoActionType = action.payload;
    },
    setAccessoryPriceUnit: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.accessory.apoPriceUnit = action.payload;
    },
    initiateSelectedLsp: (state) => {
      state.lsp.selectedLsp = [];
    },
    initiateLspPO: (state) => {
      state.lsp.selectedLspPO = undefined;
      state.lsp.selectedLspPoID = 0;
    },
    setSelectedLsp: (state, action: PayloadAction<Array<ILsp>>) => {
      state.lsp.selectedLsp = action.payload;
    },
    setSelectedLspPO: (state, action: PayloadAction<ILspPOrder>) => {
      state.lsp.selectedLspPO = action.payload;
    },
    setSelectedLspPoId: (state, action: PayloadAction<number>) => {
      state.lsp.selectedLspPoID = action.payload;
    },
    setLspoActionType: (state, action: PayloadAction<PurchaseOrderMode>) => {
      state.lsp.lspoActionType = action.payload;
    },
  },
});

export const {
  initiateSelectedYarn,
  // setSelectedYarn,
  setSelectedYarnPO,
  initiateYarnPO,
  setSelectedYarnPoId,
  setYpoActionType,
  initiateAccessoryPO,
  initiateSelectedAccessory,
  setSelectedAccessoryPO,
  setSelectedAccessoryPoId,
  setAccessoryActionType,
  initiateSelectedLsp,
  initiateLspPO,
  //setSelectedLsp,
  setSelectedLspPO,
  setSelectedLspPoId,
  setLspoActionType
} = selectedPurchaserSlice.actions;

export default selectedPurchaserSlice.reducer;
